import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/car-drive",
    name: "CarDrive",
    component: () => import("../views/CarDrive.vue")
  },
  {
    path: "/safety",
    name: "Safety",
    component: () => import("../views/Safety.vue")
  },
  {
    path: "/drive-control",
    name: "DriveControl",
    component: () => import("../views/DriveControl.vue")
  },
  {
    path: "/audio",
    name: "Audio",
    component: () => import("../views/Audio.vue")
  },
  {
    path: "/interior",
    name: "Interior",
    component: () => import("../views/Interior.vue")
  },
  {
    path: "/color-and-accessories",
    name: "Color",
    component: () => import("../views/Color.vue")
  },
  {
    path: "/timeline",
    name: "Timeline",
    component: () => import("../views/Timeline.vue")
  },
  {
    path: "*",
    redirect: {
      name: "home"
    }
  }
];

const router = new VueRouter({
  mode: "history",
  linkExactActiveClass: "is-active",
  base: process.env.BASE_URL,
  routes
});

export default router;
